<div class="grant-page">

  @if (pageLoading) {
    <app-loading-overlay [visible]="true" [indeterminate]="true"></app-loading-overlay>
  } @else {

  <!-- Back to Dashboard (Figma 596-5182 / mobile 649-2864) -->
  <div class="grant-back-row">
    <app-back-button />
  </div>

  <!-- Page Header -->
  <div class="grant-header">
    <div class="grant-title-group">
      <h1 class="grant-title">{{ 'fund.actions.grant.title' | translateLang }}</h1>
      <p class="grant-subtitle">{{ 'grant.subtitle' | translateLang }}</p>
    </div>
    @if (fundService.selectedFund() && fundService.funds().length > 0 && currentStep === 1) {
      <app-fund-switcher
        [funds]="fundService.funds()"
        [selectedFundId]="fundService.selectedFundId()"
        [variant]="'yellow'"
        [numberFormat]="numberFormatConfig"
        (fundChanged)="onFundChanged($event)"
      />
    }
  </div>

  <!-- Step Indicator -->
  <div class="stepper-container">
    <app-stepper [steps]="stepperSteps" [activeStepIndex]="activeStepIndex" />
  </div>

  <!-- Step 1: Form -->
  <div [hidden]="currentStep !== 1">
    <div class="form-content">
      <app-grant-form
        [currentFund]="currentFund"
        [showRecurring]="recurringEnabled"
        [preSelectedCharityName]="preSelectedCharityName"
        [preSelectedProjectName]="preSelectedProjectName"
        [charityHash]="charityHash"
        [lockCharityAfterSelection]="lockCharityAfterSelection"
        [minimumGrantAmount]="minimumGrantAmount"
        [displayCurrencySymbol]="fundService.selectedCurrency()?.symbol || null"
        [grantingCurrencyBalance]="fundService.selectedCurrency()?.availableAmountFundCash ?? null"
        (formChangedEvent)="grantFormData = $event"
        (formIsValid)="grantFormValid = $event"
        (grantDataFeeEmit)="grantDataFee = $event"
      />
    </div>
    <div class="button-container">
      <p class="step-counter">{{ 'contribute.step_counter' | translateLang: { current: currentStep, total: stepperSteps.length } }}</p>
      <button
        type="button"
        class="lg-button form-next-button"
        [disabled]="!grantFormValid"
        (click)="goToSummary()"
      >
        {{ 'common.next' | translateLang }}
      </button>
    </div>
  </div>

  <!-- Step 2: Summary -->
  @if (currentStep === 2) {
    @if (loading) {
      <app-loading-overlay [visible]="true" [indeterminate]="true"></app-loading-overlay>
    } @else {
      <div class="form-content">
        @if (showError) {
          <div class="alert-box">{{ 'grant.error.server' | translateLang }}</div>
        }
        @if (isMinAmountError) {
          <div class="alert-box">{{ 'grant.error.not_minimum_amount' | translateLang }}</div>
        }
        <app-grant-summary
          [displayData]="grantDisplayData"
          [currency]="fundService.selectedCurrency()?.symbol || currentFund?.currencySymbol"
          [currentFund]="currentFund"
        />
      </div>
      <div class="button-container">
        <p class="step-counter">{{ 'contribute.step_counter' | translateLang: { current: currentStep, total: stepperSteps.length } }}</p>
        <div class="button-row">
          <button type="button" class="lg-button form-back-button" (click)="goToForm()">
            {{ 'common.back' | translateLang }}
          </button>
          <button type="button" class="lg-button form-next-button" (click)="onSubmit()">
            {{ 'common.next' | translateLang }}
          </button>
        </div>
      </div>
    }
  }

  <!-- Step 3: Confirmation -->
  @if (currentStep === 3) {
    <div class="form-content form-content--completion">
      <div class="completion-card">
        <h2 class="completion-title">{{ 'grant.completion.thank_you' | translateLang }}</h2>
        <p class="completion-subtitle">{{ 'grant.completion.sent' | translateLang }}</p>
        <div class="completion-pending-box">
          @if (grantFormData?.timing === 'recurring') {
            <p
              class="completion-body"
              [innerHTML]="'grant.completion.recurring.see_manage' | translateLang : { link: '/fund/manage-recurring?type=grant' }"
            ></p>
          } @else {
            <p
              class="completion-body"
              [innerHTML]="'grant.completion.see_pending' | translateLang : { link: urls.FUND + '/' + urls.ACTIVITY + '/' + urls.PENDING }"
            ></p>
          }
        </div>
      </div>
    </div>
    <div class="button-container">
      <p class="step-counter">{{ 'contribute.step_counter' | translateLang: { current: currentStep, total: stepperSteps.length } }}</p>
      @if (grantFormData?.timing === 'recurring') {
        <button type="button" class="lg-button form-next-button" (click)="reloadGrant()">
          {{ (currentFund?.fundType === fundTypes.CHARITY ? 'grant.completion.another_distribution' : 'grant.completion.another_grant') | translateLang }}
        </button>
      } @else {
        <div class="button-row">
          <button type="button" class="lg-button form-next-button" (click)="reloadGrant()">
            {{ (currentFund?.fundType === fundTypes.CHARITY ? 'grant.completion.another_distribution' : 'grant.completion.another_grant') | translateLang }}
          </button>
          <button type="button" class="lg-button form-back-button" (click)="goToDashboard()">
            {{ 'grant.completion.back_to_dashboard' | translateLang }}
          </button>
        </div>
      }
    </div>
  }

  } <!-- end @else pageLoading -->

</div>
